import { Calendar, Search, X } from "lucide-react";
import "./DailyReportsFilters.css";
import { useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useTheme } from "../../contexts/ThemeContext";
import { dateToDateString, getTodayDate } from "../../utils/date.utils";

export type DailyReportsFilters = {
  start_date: string;
  end_date: string;
  report_id?: string;
};

interface DailyReportsFiltersProps {
  onSearch: (filters: DailyReportsFilters) => void;
  isLoading: boolean;
}

function DailyReportsFiltersComponent({ onSearch, isLoading }: DailyReportsFiltersProps) {
  const [reportId, setReportId] = useState<string>('');
  const [startDate, setStartDate] = useState<Date>(getTodayDate());
  const [endDate, setEndDate] = useState<Date>(getTodayDate());
  const { theme } = useTheme();

  const handleSearch = () => {
    if (!startDate || !endDate) return;
    onSearch(getFilters());
  };

  const getFilters = (): DailyReportsFilters => {
    return {
      start_date: dateToDateString(startDate),
      end_date: dateToDateString(endDate),
      ...(reportId && { report_id: reportId }),
    }
  }

  const handleStartDateChange = (date: Date | null) => {
    if (date) setStartDate(date);
  };

  const handleEndDateChange = (date: Date | null) => {
    if (date) setEndDate(date);
  };

  const handleClearInput = () => {
    setReportId('');
  };
  
  return (
    <div className="container">
      <div className="left-aligned-filters">
        {/* Search by Report Id */}
        <div className="id-filter-container">
          <label htmlFor="reportId">Buscar por ID de Reporte</label>
          <div className="inputWrapper">
            {reportId ? (<X className="icon clear-icon" onClick={handleClearInput} />) : <Search className="icon search-icon" />}
            <input
              type="text"
              value={reportId}
              onChange={(e) => setReportId(e.target.value)}
              className="inputSearch"
              name="reportId"
              placeholder="ID de Reporte"
            />
          </div>
        </div>
      </div>

      <div className="right-aligned-filters">
        {/* Filter by Date From */}
        <div className="date-filter-container">
          <label htmlFor="fromDate">Desde</label>
          <div className="inputWrapper">
            <Calendar className="icon" />
            <DatePicker
              selected={startDate}
              onChange={handleStartDateChange}
              className="inputDate"
              dateFormat="dd/MM/yyyy"
              placeholderText="dd/mm/aaaa"
              wrapperClassName="date-picker-wrapper"
              calendarClassName={`date-picker-calendar ${theme}`}
            />
          </div>
        </div>

        {/* Filter by Date To */}
        <div className="date-filter-container">
          <label htmlFor="toDate">Hasta</label>
          <div className="inputWrapper">
            <Calendar className="icon" />
            <DatePicker
              selected={endDate}
              onChange={handleEndDateChange}
              className="inputDate"
              dateFormat="dd/MM/yyyy"
              placeholderText="dd/mm/aaaa"
              wrapperClassName="date-picker-wrapper"
              calendarClassName={`date-picker-calendar ${theme}`}
            />
          </div>
        </div>

        {/* Search Button */}
        <div>
          <button 
            className="searchButton" 
            onClick={handleSearch}
            disabled={isLoading || !startDate || !endDate}
          >
            {isLoading ? 'Buscando...' : 'Buscar'}
          </button>
        </div>
      </div>
    </div>
  );
}

export default DailyReportsFiltersComponent; 